import { render } from "./RankingPerformanceAttendants.vue?vue&type=template&id=513acec7&ts=true"
import script from "./RankingPerformanceAttendants.vue?vue&type=script&lang=ts"
export * from "./RankingPerformanceAttendants.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__